/* eslint-disable */
import { useTranslation } from 'react-i18next';
import principes from '@assets/img/principes.svg';
import { FiLock } from 'react-icons/fi';
import { RiNewspaperLine } from 'react-icons/ri';
import { ImCoinEuro } from 'react-icons/im';
import { AiOutlineUser } from 'react-icons/ai';

function Carefree() {
  const { t } = useTranslation();
  return (
    <div className="w-full bg-[#f5f5f5] py-[6.25rem]">
      <div className="w-10/12 flex  flex-col items-center xl:flex-row m-auto justify-around">
        <div className="w-1/2">
          <img src={principes} alt="principes.svg" className="w-[16rem] m-auto" />
        </div>
        <div className="w-10/12 xl:w-1/2">
          <h2 className="font-bold text-primary text-[2.5rem] max-w-[30.5rem] mb-[3.125rem]">
            {t('carefree.title')}
          </h2>
          <div className="flex flex-row flex-wrap">
            <div className="flex-[50%] xl:flex-[33%] mb-[3rem]">
              <div className="mb-[1rem]">
                <FiLock className="text-primary text-[1.75rem]" />
              </div>
              <div className="text-[#999] text-[0.875rem] font-normal max-w-[18.25remem] xl:max-w-[7.375em]">
                {t('carefree.noPreconditions')}
              </div>
            </div>
            <div className="flex-[50%] xl:flex-[33%] mb-[3rem]">
              <div className="mb-[1rem]">
                <RiNewspaperLine className="text-primary text-[1.75rem]" />
              </div>
              <div className="text-[#999] text-[0.875rem] font-normal max-w-[18.25remem] xl:max-w-[7.375em]">
                {t('carefree.easyToClose')}
              </div>
            </div>
            <div className="flex-[50%] xl:flex-[33%] mb-[3rem]">
              <div className="mb-[1rem]">
                <ImCoinEuro className="text-primary text-[1.75rem]" />
              </div>
              <div className="text-[#999] text-[0.875rem] font-normal max-w-[18.25remem] xl:max-w-[7.375em]">
                {t('carefree.competitivePremium')}
              </div>
            </div>
            <div className="flex-[50%] xl:flex-[33%] mb-[3rem]">
              <div className="mb-[1rem]">
                <FiLock className="text-primary text-[1.75rem]" />
              </div>
              <div className="text-[#999] text-[0.875rem] font-normal max-w-[18.25remem] xl:max-w-[7.375em]">
                {t('carefree.coverage')}
              </div>
            </div>
            <div className="flex-[50%] xl:flex-[33%] mb-[3rem]">
              <div className="mb-[1rem]">
                <AiOutlineUser className="text-primary text-[1.75rem]" />
              </div>
              <div className="text-[#999] text-[0.875rem] font-normal max-w-[18.25remem] xl:max-w-[7.375em]">
                {t('carefree.yourInterest')}
              </div>
            </div>
            <div className="flex-[50%] xl:flex-[33%] mb-[3rem]"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Carefree;
